<!-- 实训考核弹窗 -->
<template>
  <div class="training-assessment">
    <!-- 添加考核 -->
    <gat-popup
      :class="['add-assessment', popupActive === 'addAssessment' ? 'on' : 'off',]"
      :title="`添加考核（共 ${assessmentItems} 项考核）`"
      :primary-button="withdrawReleaseStatus?'退出':'保存'"
      @cancel="cancelPopup"
      @confirm="onAddAssessment"
    >
      <template v-slot:content>
        <div class="popup-content-add">
          <div class="fraction">
            <span class="total-score">总分数：<span class="span-blue">100</span></span>
            <span class="span-red">*请勾选并设置需要的考核内容及分值比例。</span>
          </div>
          <div class="assessment-content">
            <div class="content-settings">
              <div class="content-settings-title">
                <span>考核内容：得分项</span>
                <span>自动判分</span>
                <span>分值比例</span>
              </div>

              <ul class="ul">
                <li v-for="(item, index) in appraisalSettingsData" :key="index">
                  <div class="li" v-if="item.type == 1">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      <div>实训流程考核：完成实训项目则得分。</div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        :disabled="withdrawReleaseStatus || !item.checked"
                        @change="switchChange(item, index)"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 2">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      <div>指标考核：当<span class="span-red">数据集名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        :disabled="withdrawReleaseStatus || !item.checked"
                        @change="switchChange(item, index)"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 3">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      <div>指标考核：当<span class="span-red">标签名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        :disabled="withdrawReleaseStatus || !item.checked"
                        @change="switchChange(item, index)"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 4">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      <div>指标考核：当<span class="span-red">模型名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        :disabled="withdrawReleaseStatus || !item.checked"
                        @change="switchChange(item, index)"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <!-- 模型评估指标值 -->
                  <div class="li li-model-evaluation" v-if="item.type == 5">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      
                      <div class="model-evaluation-table">
                        <p>指标考核：当<span class="span-red">模型评估指标值（N）</span>为指定数值时，则得分。</p>
                        <table class="evaluation-table"> 
                          <tr>
                            <th>得分关键值
                              <el-tooltip effect="light" content="学生题解只要符合设置的关键值，即可按对应百分比得分。" placement="top">
                                <i class="icon-question-mark"></i>
                              </el-tooltip>
                              <i class="td-line"></i>
                            </th>
                            <th>得分值</th>
                          </tr>
                          <tr> 
                            <td class="scale-line-td">
                              <div class="scale-line-itm">
                                <span>选取区间值：</span>
                                <span>
                                  <span
                                    id="scale-line-span"
                                    :class="['scale-line-span', {'events-disable': withdrawReleaseStatus}]"
                                    @mouseleave="leave()"
                                  >
                                    <i 
                                      :class="['i', {'scale-line-span-i': filterValueList(i)}]"
                                      :id="`line-i-${i}`"
                                      v-for="i in 99"
                                      :key="i"
                                      @click.stop="addIntervalValue(i)"
                                      @mouseenter="enter(i)"
                                      @mousedown="sedown(i)"
                                      @mouseup="seup()"
                                    >
                                      <i :class="{'i-scale': scaleFilterFun(i)}"></i>
                                      <em id="em-text" v-show="filterValueList(i)">
                                        <span @mouseenter="closeEnter">{{filterValueListText(i)}}</span>
                                        <i class="el-icon-close" @click.stop="deleteIntervalValue(i)" @mouseenter="closeEnter"></i>
                                        <i class="el-icon-caret-bottom" @mouseenter="closeEnter"></i>
                                      </em>
                                    </i>
                                  </span>
                                  <span class="span-scale-value">
                                    <i>0</i>
                                    <i>0.5</i>
                                    <i>1</i>
                                  </span>
                                </span>
                                <span 
                                  class="el-icon-plus"
                                  v-show="cursorData.iconShow"
                                  :style="`position: fixed; left: ${cursorData.leftX}px; top: ${cursorData.rightY}px;`"
                                ></span>
                              </div>
                              <p class="p-text-min">* 鼠标点击刻度线可添加指标区间值</p>
                            </td> 
                            <td></td> 
                          </tr> 
                          <tr v-for="(itm, idx) in item.intervalvalueList" :key="idx"> 
                            <td class="intervalvalueList-td">
                              <span class="icon-index">{{idx+1}}</span>
                              <div class="intervalvalueList-td-itm">
                                <span>{{itm.min}}</span>
                                <span v-text="'<'"></span>
                                <span>N</span>
                                <span>≤</span>
                                <span>{{itm.max}}</span>
                              </div>
                            </td> 
                            <td class="input-td">
                              <el-input
                                type="text"
                                :id="'text'+idx"
                                v-model="itm.scoreProportion"
                                @blur="onBlurScoreValue(index, idx, itm.scoreProportion, item.type)"
                                :disabled="withdrawReleaseStatus || !item.checked"
                              ></el-input>
                              <span>&nbsp;%</span>
                            </td>
                          </tr> 
                        </table> 
                      </div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        @change="switchChange(item, index)"
                        :disabled="withdrawReleaseStatus || !item.checked"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <!-- 目标校验对象的校验结果 -->
                  <div class="li li-model-evaluation" v-if="item.type == 6">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      
                      <div class="model-evaluation-table">
                        <p>指标考核：当<span class="span-red">目标校验对象的校验结果（X）</span>为指定数值时，则得分。</p>
                        <table class="target-verification-table"> 
                          <tr>
                            <th>得分关键值
                              <el-tooltip effect="light" content="学生题解只要符合设置的关键值，即可按对应百分比得分。" placement="top">
                                <i class="icon-question-mark"></i>
                              </el-tooltip>
                              <i class="td-line"></i>
                            </th>
                            <th>分值比例</th>
                          </tr>
                          <tr> 
                            <td>
                              <span class="span">校验对象</span>  
                              <span class="span">预测分类</span>  
                              <span class="span">置信度</span>  
                              <span class="span">置信度区间</span>  
                            </td> 
                            <td>/</td> 
                          </tr> 
                          <tr v-for="(itm, idx) in item.intervalvalueList" :key="idx"> 
                            <td>
                              <span class="span img-span">
                                <img v-if="modelType == 1 || modelType == 2" :src="photoBaseUrl + itm.fileUrl" @click="onFilePreview(itm.fileUrl)" title="预览" alt="" />
                                <img v-if="modelType == 3 || modelType == 4" src="@/assets/images/txtImage@2x.png" @click="onFilePreview(itm.fileUrl)" title="预览" alt="" />
                                <img v-if="modelType == 5 || modelType == 6" src="@/assets/images/audioImage@2x.png" @click="onFilePreview(itm.fileUrl)" title="预览" alt="" />
                              </span>
                              <span class="span table-td-list">
                                <span class="table-td-item" v-for="(val, l) in itm.nameList" :key="l" :title="val.labelName">{{val.labelName || "-"}}</span>
                              </span>
                              <span class="span table-td-list">
                                <span class="table-td-item" v-for="(val, l) in itm.nameList" :key="l">{{val.confidence || "-"}}</span>
                              </span>
                              <span class="span confidence-interval-span">
                                <el-input
                                  type="text"
                                  :id="'interval'+idx"
                                  v-model="itm.section"
                                  @blur="onBlurIntervalValue(index, idx, itm.section, item.type)"
                                  :disabled="withdrawReleaseStatus || !item.checked"
                                ></el-input>&nbsp;~&nbsp;1
                              </span>
                            </td> 
                            <td class="input-td">
                              <el-input
                                type="text"
                                :id="'text'+idx"
                                v-model="itm.scoreProportion"
                                @blur="onBlurScoreValue(index, idx, itm.scoreProportion, item.type)"
                                :disabled="withdrawReleaseStatus || !item.checked || itm.nameList.length === 0"
                              ></el-input>
                              <span>&nbsp;%</span>
                            </td> 
                          </tr> 
                        </table> 
                      </div>
                    </div>
                    <div class="switch-div">
                      <el-switch
                        v-model="item.automaticScoringState"
                        active-color="#4c88ff"
                        inactive-color="#DCDFE6"
                        @change="switchChange(item, index)"
                        :disabled="withdrawReleaseStatus || !item.checked"
                      ></el-switch>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <!-- 自定义考核内容 -->
                  <div class="li li-model-evaluation li-border-none" v-if="item.type == 7">
                    <div class="checked-settings">
                      <el-checkbox v-model="item.checked" @change="checkedChange(item, index)" :class="{'events-disable': withdrawReleaseStatus}"></el-checkbox>
                      
                      <div class="model-evaluation-table">
                        <p>自定义考核：当<span class="span-red">自定义考核内容</span>符合实训任务要求时，则得分。</p>
                        <p class="span-red p-text-min">* 本项为老师主观定义的考核，可根据具体实训要求设置，系统不作自动判分。</p>
                        <div class="custom-content">
                          <span>自定义内容：</span>
                          <el-input
                            class="score-text"
                            placeholder="请输入自定义考核内容"
                            v-model.trim="item.customValue"
                            type="textarea"
                            :rows="3"
                            maxlength="200"
                            show-word-limit
                            :disabled="withdrawReleaseStatus || !item.checked"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="switch-div"></div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" @blur="inputScoreProportion(item.scoreProportion, index)" :disabled="withdrawReleaseStatus || !item.checked"></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </gat-popup>

    <!-- 学生查看实训考核详情 -->
    <gat-popup
      :class="['add-assessment', popupActive === 'seeAssessment' ? 'on' : 'off',]"
      :title="`实训考核详情 (共 ${assessmentItemsStudent} 项考核)`"
      :primary-button="'退出'"
      @cancel="cancelPopup"
      @confirm="cancelPopup"
    >
      <template v-slot:content>
        <div class="popup-content-add">
          <div class="fraction">
            <span class="total-score">总分数：<span class="span-blue">100</span></span>
          </div>
          <div class="assessment-content">
            <div class="content-settings content-settings-student">
              <div class="content-settings-title">
                <span>考核内容：得分项</span>
                <span>分值比例</span>
              </div>

              <ul class="ul">
                <li v-for="(item, index) in appraisalSettingsData" :key="index">
                  <div class="li" v-if="item.type == 1 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、实训流程考核：完成实训项目则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 2 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、指标考核：当<span class="span-red">数据集名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 3 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、指标考核：当<span class="span-red">标签名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 4 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、指标考核：当<span class="span-red">模型名称</span>与项目题解一致时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 5 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、指标考核：当<span class="span-red">模型评估指标值（N）</span>为指定数值时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li" v-if="item.type == 6 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、指标考核：当<span class="span-red">目标校验对象的校验结果（X）</span>为指定数值时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                  <div class="li li-border-none" v-if="item.type == 7 && item.scoreProportion != 0">
                    <div class="checked-settings">
                      <div>{{item.orderIndex}}、自定义考核：当<span class="span-red">自定义考核内容</span>符合实训任务要求时，则得分。</div>
                    </div>
                    <div class="input-Score">
                      <el-input type="text" v-model="item.scoreProportion" disabled></el-input>
                      <span>&nbsp;%</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </gat-popup>

    <!-- 提示 -->
    <gat-popup
      :class="[
        'popup-delete popup-delete-2',
        popupActiveTips === 'popupTips' || popupActiveTips === 'popupCheckedTips' ? 'on' : 'off',
      ]"
      :title="'提示'"
      :primary-button="'确定'"
      @cancel="cancelPopupTips"
      @confirm="confirmTips"
    >
      <template v-slot:content>
        <div class="popup-del-cnt">
          <div class="head"></div>
          <div class="content">{{popupTipsText}}</div>
          <div class="popupbutton" v-if="popupActiveTips === 'popupCheckedTips'">
            <button @click="popupActiveTips=''">继续添加</button>
            <button @click="onOut">退出</button>
          </div>
        </div>
      </template>
    </gat-popup>

    <!--文件预览-->
    <file-preview
      :modelType="modelType"
      :fileUrl="fileUrl"
      :dialogvisibleview="dialogvisibleview"
      @onClickDialog="dialogvisibleview = false"
    ></file-preview>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'; // 项目标注接口

import GatPopup from '@/components/common/GatPopup';
import IconInfoHelp from '@/components/icons/typography/InfoHelp';
import FilePreview from '@/components/pretrain/FilePreview.vue'

export default {
  name: 'PopupAddAssessment',
  components: {
    GatPopup,
    IconInfoHelp,
    FilePreview,
  },
  props: {
    modelType: {
      type: String,
      default: '1'
    },
    trainingId: {
      type: String,
      default: null
    },
    // true：已发布模型，false:未发布模型
    trainModelShow: {
      type: Boolean,
      default: false,
    },
    // true:发布项目||发布项目后撤回，false:未发布项目
    withdrawReleaseStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC文件基地址
      fileUrl: '',
      dialogvisibleview: false,
      teacherOrStudentState: false,
      seen: false,
      currentIndex: 0,
      valueList: [],
      assessmentItems: 0, // 考核项数
      assessmentItemsStudent: 0, // 考核项数-学生
      appraisalSettingsData: [
        {
          type: 1,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
        },
        {
          type: 2,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
        },
        {
          type: 3,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
        },
        {
          type: 4,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
        },
        {
          type: 5,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
          intervalvalueList: []
        },
        {
          type: 6,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
          intervalvalueList: []
        },
        {
          type: 7,
          checked: false,
          automaticScoringState: false,
          scoreProportion: '0',
          customValue: ''
        },
      ],
      popupActive: '',
      popupActiveTips: '',
      popupTipsText: '',
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      cursorData: {
        iconShow: true,
        leftX: 0,
        rightY: 0,
      }
    }
  },
  watch: {
    appraisalSettingsData: {
      handler(val) {
        this.assessmentItems = 0;
        val.forEach(item => {
          if (item.checked) {
            this.assessmentItems++;
          }
          if (item.type == 5 && item.intervalvalueList.length == 0) {
            this.valueList = []
          }
        });
      },
      deep: true,
      immediate: true
    },
    // valueList(val) {
    //   if (val.length) {
    //     val.forEach(item => {
    //       item = parseInt(item)
    //     });
    //   }
    // },
  },
  created() {
    let userRole = this.$store.state.userRole;
    // userRole: 1老师，2学生，3校管理员，4超级管理员
    if (userRole === 2) {
      this.teacherOrStudentState = false;
    } else {
      this.teacherOrStudentState = true;
    }
  },
  mounted() {
    //鼠标指针移动到元素上时触发
    setTimeout(() => {
      this.overShow()
    }, 100);
  },
  methods: {
    // 预览文件
    onFilePreview(imgUrl) {
      this.fileUrl = this.photoBaseUrl + imgUrl;
      this.dialogvisibleview = true;
    },
    // 模型评估指标值区间点选中处理为数组列表
    getModelEvaluationIndexValue() {
      this.appraisalSettingsData.forEach(item => {
        if (item.type == 5) {
          let list = [];
          item.intervalvalueList.forEach(item => {
            if (item.min != 0) {
              list.push(item.min);
            }
            if (item.max != 1) {
              list.push(item.max);
            }
          });
          let newArr = this.arrayDuplication(list); // 数组去重
          let valueList = [];
          newArr.forEach(itm => {
            valueList.push(itm * 100);
          });
          this.valueList = valueList;
        }
      });
    },
    // 目标检验结果区间值处理
    getTargetVerificationIntervalValue() {
      this.appraisalSettingsData.forEach(item => {
        if (item.type == 6) {
          item.intervalvalueList.forEach(item => {
            let confidence = 1;
            let nameList = item.nameList;
            if (nameList && nameList.length) {
              nameList.forEach(itm => {
                confidence = itm.confidence < confidence ? itm.confidence : confidence;
              });
            } else {
              confidence = 0;
            }
            item.section = confidence - 0.1 >= 0 ? `${confidence - 0.1}` : '0';
            item.section = item.section.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3'); // 只能输入4个小数
            item.section = item.section.replace(/(?:\.0*|(\.\d+?)0+)$/,'$1'); // 清除小数点后面无用的0
          });
        }
      });
    },
    // 数组去重
    arrayDuplication(list) {
      let newArr = list.reduce((pre,cur) => {
        if(!pre.includes(cur)) {
          return pre.concat(cur);
        } else {
          return pre;
        }
      },[])
      return newArr;
    },
    //鼠标指针移动到元素上时触发
     overShow() {
      let this_ = this
      let showLine = document.getElementById('scale-line-span');
      showLine.onmouseover = function (event) {
        this_.cursorData = {
          iconShow: true,
          leftX: event.clientX + 7,
          rightY: event.clientY + 16,
        }
      }
      showLine.onmouseout = function () {
        // console.log('移出')
        this_.cursorData.iconShow = false;
      }
    },
    // 检测过滤出添加的刻度值
    filterValueList(index) {
      return this.valueList.some(item => {
        return item === index
      });  
    },
    // 刻度过滤逢10的倍数
    scaleFilterFun(index) {
      let flag = false;
      let indexStr = index.toString();
      if (indexStr.indexOf('0') !== -1) {
        flag = true
      }
      return flag
    },
    filterValueListText(index) {
      let value = 0;
      this.valueList.forEach(item => {
        if (item === index) {
          value = item;
        }
      });
      return value / 100
    },
    // 数组排序
    sortFun(val) {
      let arr = val;
      for (var i=0; i<arr.length-1; i++) {
        for (var j=0; j<arr.length-i-1; j++) {
          if (arr[j] > arr[j+1]) {
            var temp = arr[j];
            arr[j] = arr[j+1];
            arr[j+1] = temp;
          } 
        }
      }   
      return arr
    },
    valueListFun(val) {
      let dataList = this.appraisalSettingsData;
      if (val.length !== 0) {
        let valueList = [];
        // 数组排序
        let arr = this.sortFun(val);
        // let arr = val.sort((a, b) => {
        //   return a - b
        // }); 
        // 区间追加处理
        if (arr.length !== 0) {
          valueList.push(
            {
              min: 0,
              max: arr[0] / 100,
              scoreProportion: '0',
            }
          );
          arr.forEach((item, index) => {
            valueList.push(
              {
                min: item / 100,
                max: arr.length == index+1 ? 1 : arr[index+1] / 100,
                scoreProportion: '0',
              }
            )
          });
        }

        dataList.forEach(item => {
          if (item.type == 5) {
            item.intervalvalueList = valueList;
          }
        });
      } else {
        dataList.forEach(item => {
          if (item.type == 5) {
            item.intervalvalueList = [];
            item.automaticScoringState = false;
          }
        });
      }
    },
    // 添加区间值
    addIntervalValue(index) {
      if (this.valueList.length < 5) {
        this.valueList.push(index);
        this.valueList = this.arrayDuplication(this.valueList); // 数组去重
        this.valueListFun(this.valueList);
      }
    },
    // 删除区间值
    deleteIntervalValue(index) {
      if (this.valueList.length !== 0) {
        this.valueList.forEach((item, idx) => {
          if (item == index) {
            this.valueList.splice(idx, 1);
            this.valueListFun(this.valueList);
          }
        });
      }
    },
    closeEnter() {
      this.cursorData.iconShow = false;
    },
    // 鼠标移入
    enter(index) {
      let valueListFlag = this.filterValueList(index); // 判断列表中有无拖动的标注值
      if (this.seen) {
        if (valueListFlag) {
          this.leave();
          return
        }
        let list = JSON.parse(JSON.stringify(this.valueList));
        list[this.currentIndex] = index;
        this.valueList = list;
        this.valueListFun(this.valueList);
      }

      if (valueListFlag) {
        this.cursorData.iconShow = false;
      }
    },
    // 鼠标移出
    leave() {
      this.seen = false;
      this.currentIndex = null;
    },
    // 鼠标按下
    sedown(index) {
      this.seen = this.filterValueList(index);
      if (this.seen) {
        this.valueList.forEach((item, idx) => {
          if (item === index) {
            this.currentIndex = idx;
          }
        });
      }
      
    },
    // 鼠标抬起
    seup() {
      this.seen = false;
      this.current = null;
    },
    // 开启自动评分
    switchChange(value, index) {
      // let scoreValueAll = 0;
      let list = this.appraisalSettingsData[index].intervalvalueList;
      // list.forEach(item => {
      //   scoreValueAll += Number(item.scoreProportion);
      // });

      if (value.type == 5 && list && list.length == 0) {
        this.appraisalSettingsData[index].automaticScoringState = false;
        return this.$message.error(`此项若需要自动判分，请先添加得分关键值。`);
      }

      if (this.appraisalSettingsData[index].automaticScoringState) {
        this.$message.success(`已开启自动评分`);
      } else {
        this.$message.success(`已关闭自动评分`);
      }
    },
    // 勾选考核项
    checkedChange(value, index) {
      if (value.type == 6 && !this.trainModelShow) {
        this.appraisalSettingsData[index].checked = false;
        return this.$message.error(`请先完成项目实训并发布模型，再设置该项考核哦~`);
      }
      if (value.checked) {
        let list = this.appraisalSettingsData,
          score = 100;
        list.forEach(item => {
          score = score - item.scoreProportion;
        });
        score = score >= 0 ? score : '0';
        this.appraisalSettingsData[index].scoreProportion = `${score}`;
      } else {
        this.appraisalSettingsData[index].scoreProportion = '0';
      }
    },
    // 分值数据处理
    clearNoNum (value) {
      value = value.toString();
      value = value.replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g,""); //验证第一个字符是数字
      value = value.replace(/\.{2,}/g,"."); //只保留第一个, 清除多余的
      value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
      if(value.indexOf(".") < 0 && value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
        if(value.substr(0,1) == '0' && value.length == 2){ 
          value = parseFloat(value);     
        } 
      }
      return value
    },
    // 分值比例判断是否超过100%
    inputScoreProportion(value, index) {
      // value = value !== '' ? value.replace(/[^0-9.]/g,'0') : '0';
      value = this.clearNoNum(value); // 分值数据处理
      value = value !== '' ? `${parseInt(value)}`: '0';
      this.appraisalSettingsData[index].scoreProportion = value;

      if (!value || value == 0) {
        return this.$message.error(`分值比例不能为0，请输入分值比例!`);
      }

      let list = this.appraisalSettingsData;
      // 总分值比例检验
      let scoreAll = this.filterScoreList(list);
      if (scoreAll > 100 ) {
        this.$message.error(`分值比例总和不能超过100%，请修改！`);
      }
    },
    // 总分值比例检验
    filterScoreList(list) {
      let scoreAll = 0;
      list.forEach(item => {
        if (item.checked) {
          scoreAll = scoreAll + Number(item.scoreProportion);
        }
      });
      return scoreAll;
    },
    // 得分值/得分比例检验
    onBlurScoreValue(index, idx, value, type) {
      let msg = type == 5 ? '得分值' : '得分比例';
      if (value > 100) {
        return this.$message.error(`${msg}不能超过100%，请修改！`);
      }
      // value = value !== '' ? value.replace(/[^0-9.]/g,'0') : '0';
      value = this.clearNoNum(value); // 分值数据处理
      value = value !== '' ? `${parseInt(value)}`: '0';
      this.appraisalSettingsData[index].intervalvalueList[idx].scoreProportion = value;

      if (type == 6) {
        let scoreValueAll = 0;
        let list = this.appraisalSettingsData[index].intervalvalueList;
        list.forEach(item => {
          scoreValueAll += Number(item.scoreProportion);
        });
        if (scoreValueAll > 100) {
          this.$message.error(`关键词总${msg}不能超过100%，请修改！`);
        }
        if (scoreValueAll <= 0) {
          this.$message.error(`关键词总${msg}不能低于0%，请修改！`);
        }
      }
    },
    clearNoNumIntervalValue (value) {
      value = value.toString();
      value = value.replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g,""); //验证第一个字符是数字
      value = value.replace(/\.{2,}/g,"."); //只保留第一个, 清除多余的
      value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
      value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/,'$1$2.$3'); //只能输入4个小数
      if(value.indexOf(".") < 0 && value !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
        if(value.substr(0,1) == '0' && value.length == 2){ 
          value = parseFloat(value);     
        } 
      }
      return value
    },
    // 置信度区间值检验
    onBlurIntervalValue(index, idx, value, type) {
      value = this.clearNoNumIntervalValue(value); // 分值数据处理
      value = value !== '' ? value: '0';
      if (value > 1) {
        value = '1';
      }
      this.appraisalSettingsData[index].intervalvalueList[idx].section = value;
    },

    // 查看实训考核
    seeTrainingAssessment(res) {
      if (this.teacherOrStudentState) {
        this.seeTeacherAssessment(res); // 查看实训考核-老师
        this.popupActive = 'addAssessment';
      } else {
        this.seeStudentAssessment(res); // 查看实训考核-学生
        this.popupActive = 'seeAssessment';
      }
    },
    // 查看实训考核-学生
    seeStudentAssessment(res) {
      let orderIndex = 0;
      this.appraisalSettingsData.forEach(item => {
        item.scoreProportion = '0';
      });
      if (res) {
        this.appraisalSettingsData.forEach(item => {
          if (item.type == 1) {
            item.scoreProportion = res.processRatio; // 流程考核比例
            orderIndex = res.processRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 2) {
            item.scoreProportion = res.datasetRatio; // 数据集考核比例
            orderIndex = res.datasetRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 3) {
            item.scoreProportion = res.labelRatio; // 标签考核比例
            orderIndex = res.labelRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 4) {
            item.scoreProportion = res.modelRatio; // 模型考核比例
            orderIndex = res.modelRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 5) {
            item.scoreProportion = res.indexRatio; // 模型评估指标考核比例
            orderIndex = res.indexRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 6) {
            item.scoreProportion = res.checkRatio; // 目标校验对象的校验结果考核比例
            orderIndex = res.checkRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          } else if (item.type == 7) {
            item.scoreProportion = res.customRatio; // 自定义考核比例
            orderIndex = res.customRatio != '0' ? orderIndex+1 : orderIndex
            item.orderIndex = orderIndex
          }
        });
        this.assessmentItemsStudent = orderIndex
      }
    },
    // 查看实训考核-老师
    seeTeacherAssessment(res) {
      // 初始默认值
      this.appraisalSettingsData.forEach(item => {
        item.checked = false;
        item.automaticScoringState = false;
        item.scoreProportion = '0';
        item.customValue = '';
        item.intervalvalueList = [];
      });
      this.valueList = [];

      if (res) {
        let checkData = res.checkData || [];
        let checkDataList = []; // 存储默认返回的检验结果
        checkData.forEach(item => {
          checkDataList.push({
            fileUrl: item.fileUrl || '',
            nameList: item.nameList && item.nameList.length != 0 ? item.nameList : [],
            section: item.section || '0',
            scoreProportion: item.scoreProportion || '0',
          });
        });

        let assessData = res.assessData || [];
        // 返回设置了的考核项
        if (assessData && assessData.length !== 0) {
          assessData.forEach(item => {
            this.appraisalSettingsData.forEach(i => {
              // 查询赋值
              if (item.type == i.type) {
                // 已设置考核
                if (item.scoreProportion != 0) {
                  i.checked = item.scoreProportion != '0' ? true : false;
                  i.automaticScoringState = item.automaticScoringState == 1 ? true : false;
                  i.scoreProportion = item.scoreProportion || '0';
                  i.customValue = item.customValue || '';
                  if (i.type == 5) {
                    i.intervalvalueList = item.keywordList || [];
                  }
                  if (i.type == 6) {
                    i.intervalvalueList = item.keywordList || [];
                  }
                }
                // 未设置考核并且是目标检验结果考核项
                if (item.scoreProportion == 0 && i.type == 6) {
                  i.intervalvalueList = checkDataList;
                  // 目标检验结果区间值处理
                  this.getTargetVerificationIntervalValue();
                }
              }
            })
          });
        } else { // 未设置返回目标校验结果关键词
          this.appraisalSettingsData[5].intervalvalueList = checkDataList;
          // 目标检验结果区间值处理
          this.getTargetVerificationIntervalValue();
        }
        // 模型评估指标值区间点选中处理为数组列表
        this.getModelEvaluationIndexValue();
      }
    },
    // 添加考核
    addTrainingAssessment() {
      this.popupActive = 'addAssessment';
    },
    // 保存实训考核
    onAddAssessment() {
      if (this.withdrawReleaseStatus) {
        return this.popupActive = ''
      }
      let list = this.appraisalSettingsData,
       scoreAll =  this.filterScoreList(list);

      let checkedAllFlag = list.some(item => {
        return item.checked
      }); 
      if (!checkedAllFlag) {
        this.popupTipsText = '当前未勾选设置实训考核，继续添加考核吗？';
        this.popupActiveTips = 'popupCheckedTips';
        return
      }

      let scoreAllFlag = list.some(item => {
        return item.checked && item.scoreProportion == 0 
      });
      if (scoreAllFlag) {
        return this.$message.error(`勾选考核项未设置分值比例，请设置！`);
      }

      if (scoreAll > 100) {
        return this.$message.error(`分值比例总和不能超过100%，请修改！`);
      }
      if (scoreAll < 100) {
        return this.$message.error(`分值比例总和不能低于100%，请修改！`);
      }

      let keyWordFlag = false,
        intervalValFlag = false,
        scoreProportionFlag = false,
        customContentFlag = false,
        type1 = null,
        type2 = null,
        scoreValueAll1 = 0,
        scoreValueAll2 = 0;

      list.forEach(item => {
        // console.log(item.checked, item.intervalvalueList)
        if (item.checked && item.intervalvalueList && item.intervalvalueList.length) {
          item.intervalvalueList.forEach(itm => {
            if (item.type == 5) {
              type1 = item.type;
              scoreValueAll1 +=  Number(itm.scoreProportion);
              if (Number(itm.scoreProportion) > 100) {
                scoreProportionFlag = true
              }
            }
            if (item.type == 6) {
              type2 = item.type;
              scoreValueAll2 +=  Number(itm.scoreProportion);
              if (itm.section > 1) {
                intervalValFlag = true
              }
            }
          });
        }
        if (item.type == 5 && item.checked && item.intervalvalueList && item.intervalvalueList.length === 0) {
          keyWordFlag = true
        }
        if (item.checked && item.type == 7 && !item.customValue) {
          customContentFlag = true
        }
      });

      if (keyWordFlag) {
        return this.$message.error(`未添加得分值，请添加！`);
      }
      if (scoreProportionFlag && type1 == 5) {
        return this.$message.error(`得分值不能超过100%，请修改！`);
      }
      if (scoreValueAll1 <= 0 && type1 == 5) {
        return this.$message.error(`得分值总和不能低于0%，请修改！`);
      }

      if (intervalValFlag) {
        return this.$message.error(`置信度区间值不能超过1，请修改！`);
      }
      if (scoreValueAll2 > 100 && type2 == 6) {
        return this.$message.error(`关键词分值比例总和不能超过100%，请修改！`);
      }
      if (scoreValueAll2 < 100 && type2 == 6) {
        return this.$message.error(`关键词分值比例总和不能低于100%，请修改！`);
      }

      if (customContentFlag) {
        return this.$message.error('请输入自定义考核内容！');
      }

      let data = {
        assessList: [],
        trainingId: this.trainingId // 实训id
      }

      list.forEach(item => {
        if (item.checked) {
          data.assessList.push(
            {
              automaticScoringState: item.automaticScoringState ? 1 : 0, // 自动评分状态：0为不自动评分，1为自动评分
              customValue: item.customValue || '', // 自定义考核内容
              keywordList: item.type == 5 || item.type == 6 ? item.intervalvalueList : [] , // 得分关键词
              scoreProportion: item.scoreProportion, // 分数比例
              type: item.type // 类型：1为流程；2为数据集；3为标签；4为模型；5为指标；6为校验结果；7为自定义
            }
          )
        }
      });

      MARKCENTER.addTrainingCheck(data).then(result => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg);
          this.$emit("getTrainingByTrainingId"); //父组件重新获取项目信息
          this.cancelPopup();
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },

    deleteOperate() {
      this.cancelPopup();
    },
    cancelPopup() {
      this.popupActive = '';
    },
    confirmTips() {
      this.popupActiveTips = '';
    },
    cancelPopupTips() {
      this.popupActiveTips = '';
    },
    onOut() {
      this.popupActiveTips = '';
      this.popupActive = '';
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.training-assessment {
  .span-red {
    color: red;
  }
  .span-blue {
    color: #4C88FF ;
  }

  .add-assessment {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner{
      width: 1000px;
      height: 700px;
      .popup-head {
        .title {
          color: #4C88FF;
        }
      }
      .popup-content {
        padding: 0 20px;
      }
      .el-input {
        width: 50px;
        height: 20px;
        margin-top: 0;
        text-align: center;
      }
      .el-input__inner {
        width: 50px;
        height: 20px;
        padding: 0 2px;
        text-align: center;
      }
    }

    .popup-content-add {
      color: #333333;
      height: 520px;
      padding: 0;
      .fraction {
        height: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          &.total-score {
            font-size: 16px;
            margin-left: 20px;
          }
          &.span-red {
            font-size: 12px;
          }
        }
      }

      .assessment-content {
        height: 100%;
        display: flex;

        .content-settings {
          height: 100%;
          flex: 1;
          // border: 1px solid #D8E5FD;
          // border-radius: 5px;
          overflow: hidden;
          .content-settings-title {
            color: #fff;
            width: 100%;
            height: 30px;
            background: #4C88FF;
            // background: rgba(76, 136, 255, 0.7);
            border-radius: 5px 5px 0 0;
            line-height: 30px;
            padding: 0 20px;
            span {
              display: inline-block;
              text-align: center;
              &:first-child {
                width: 70%;
                text-align: left;
              }  
              &:nth-child(2) {
                width: 15%;
              }  
              &:last-child {
                width: 15%;
              }
            }
          }

          .ul {
            height: calc(100% - 50px);
            border: 1px solid #D8E5FD;
            border-radius: 0 0 5px 5px;
            padding-bottom: 30px;
            // overflow-y: scroll;
            overflow: auto;
            position: relative;
            &::-webkit-scrollbar {
              width: 8px; /*滚动条宽度*/
              height: 8px; /*滚动    条高度*/
            }
      
            /*定义滚动条轨道 内阴影+圆角*/
            // &::-webkit-scrollbar-track {
              // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
              // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
              // border-radius: 10px; /*滚动条的背景区域的圆角*/
              // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
            // }
      
            /*定义滑块 内阴影+圆角*/
            &::-webkit-scrollbar-thumb {
              border-radius: 10px; /*滚动条的圆角*/
              box-shadow: inset 0 0 6px #919BB3;
              -webkit-box-shadow: inset 0 0 6px #919BB3;
              background: #919BB3; /*滚动条的背景颜色*/
              position: absolute;
              top: 0;
              right: -10px;
            }

            .el-input {
              width: 50px;
              height: 20px;
              margin-top: 0;
              text-align: center;
            }
            /ddep/.el-input__inner {
              width: 50px;
              height: 20px;
              padding: 0 2px;
              text-align: center;
            }

            .li {
              min-height: 48px;
              font-size: 14px;
              border-bottom: 1px solid #D8E5FD;
              padding: 0 0 0 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              &.li-border-none {
                border-bottom: none;
              }
              .checked-settings {
                width: 70%;
                display: flex;

                .el-checkbox {
                  margin-right: 10px;
                }
              }
              .switch-div {
                width: 15%;
                text-align: center;
              }
              .input-Score {
                width: 15%;
                // height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }

            .li-model-evaluation {
              height: 100%;
              display: flex;
              align-items: stretch;
              .el-checkbox,
              .switch-div,
              .input-Score {
                line-height: 48px;
              }
              .input-Score {
                display: flex;
                align-items: stretch;
              }

              .model-evaluation-table {
                width: 100%;
                p {
                  height: 48px;
                  line-height: 48px;
                  padding-bottom: 5px;
                }
                .evaluation-table,
                .target-verification-table {
                  width: 100%;
                  // width: 500px;
                  border-radius: 4px;
                  overflow: hidden;
                  margin-bottom: 20px;
                  tr {
                    border: 1px solid #D8E5FD;
                    th,
                    td {
                      min-height: 40px;
                      background: #D8E5FD;
                      text-align: center;
                      border-right: 1px solid #D8E5FD;
                      &:last-child {
                        width: 20%;
                        // border-bottom: 1px solid #D8E5FD;
                      }
                    }
                    th {
                      color: #4C88FF;
                      line-height: 40px;
                      .icon-question-mark {
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        background: url('../../../../assets/images/trainingCenter/icon-question-mark.png') no-repeat;
                        background-size: 100% 100%;
                        margin-left: 5px;
                        vertical-align: middle;
                      }

                      .td-line {
                        width: 1px;
                        height: 20px;
                        background: #FFFFFF;
                        float: right;
                        margin-top: 10px;
                        margin-right: -1px;
                      }
                    }
                    td {
                      background-color: #F0F2FF;
                    }

                    .input-td {
                      input {
                        color: #666;
                        width: 40px;
                        height: 20px;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        font-size: 14px;
                        padding: 0 5px;
                        box-sizing: border-box;
                        &:focus {
                          border: 1px solid #4c88ff;
                        }
                      }
                    }
                  }
                }
                // 模型评估指标值
                .evaluation-table {
                  tr {
                    &:nth-child(2) {
                      td {
                        &:first-child {
                          border-right: none;
                        }
                        // &:last-child {
                          // border-left: none;
                        // }
                      }
                    }
                  }
                  .scale-line-td {
                    padding: 0 20px;
                    text-align: left;
                    font-size: 16px;
                    .scale-line-itm {
                      height: 70px;
                      display: flex;
                      padding-top: 30px;
                      span {
                        &:nth-child(2) {
                          width: 65%;
                          .span-scale-value {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            margin-top: 3px;
                            i {
                              font-size: 12px;
                              font-weight: 700;
                              font-style: normal;
                              &:first-child {
                                margin-left: -2px;
                              } 
                              &:last-child {
                                margin-right: -3px;
                              }
                            }
                          }
                        }
                      }
                      .scale-line-span {
                        width: 100%;
                        height: 8px;
                        display: flex;
                        .i {
                          flex: 1;
                          background-color: rgb(110, 107, 107);
                          position: relative;
                          box-sizing: border-box;
                          .i-scale {
                            width: 1px;
                            height: 8px;
                            background-color: #fff;
                            position: absolute;
                            left: 0;
                            right: 0;
                            margin: 0 auto;
                          }
                        }
                        .scale-line-span-i {
                          background-color: #4C88FF;
                          border: 1px solid #4C88FF;
                          position: relative;
                          z-index: 1;
                          box-sizing: border-box;
                          &:hover {
                            z-index: 2;
                          }
                          em {
                            color: #fff;
                            height: 15px;
                            background-color: #4C88FF;
                            border: 1px solid #fff;
                            border-radius: 5px;
                            font-size: 10px;
                            font-style: normal;
                            line-height: 15px;
                            text-align: center;
                            padding: 1px 15px 1px 5px;
                            position: absolute;
                            top: -25px;
                            left: -17px;
                            &:hover {
                              z-index: 2;
                            }
                            .el-icon-close {
                              position: absolute;
                              top: 2px;
                              right: 2px;
                              cursor: pointer;
                            }
                            .el-icon-caret-bottom {
                              width: 0;
                              color: #4C88FF;
                              padding: 0;
                              position: absolute;
                              left: 11px;
                              bottom: -8px;
                              z-index: 3;
                            }
                          }
                        }
                      }
                    }
                    p {
                      color: red;
                    }
                    .el-icon-plus {
                      color: #000;
                    }
                  }
                  .intervalvalueList-td {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .icon-index {
                      color: #fff;
                      width: 20px;
                      height: 20px;
                      line-height: 20px;
                      background-color: #4C88FF;
                      border-radius: 50%;
                      font-size: 16px;
                      margin: 0 auto;
                    }
                    .intervalvalueList-td-itm {
                      width: 75%;
                      height: 40px;
                      border-left: 1px solid #D8E5FD;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 0 20%;
                      span {
                        flex: 1;
                      }
                    }
                  }
                }
                // 目标校验对象
                .target-verification-table {
                  tr {
                    td {
                      &:first-child {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .span {
                          flex: 1;
                          min-height: 40px;
                          height: 100%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          &:nth-child(2) {
                            border-left: 1px solid #D8E5FD;
                            border-right: 1px solid #D8E5FD;
                          }
                          &:nth-child(3) {
                            border-right: 1px solid #D8E5FD;
                          }
                        }
                        .confidence-interval-span {
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        }

                        .img-span {
                          display: flex;
                          img {
                            width: 30px;
                            height: 30px;
                            cursor: pointer;
                          }
                        }
                      }

                      .table-td-list {
                        display: flex;
                        flex-direction: column;
                        .table-td-item {
                          width: 100px;
                          height: 25px;
                          border-bottom: 1px solid #D8E5FD;
                          line-height: 25px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          cursor: default;
                          &:last-child {
                            border-bottom: none;
                          }
                        }
                      }
                    }
                  }
                }

                .custom-content {
                  display: flex;
                  span {
                    width: 120px;
                  }
                }
                .p-text-min {
                  height: 12px;
                  font-size: 12px;
                  line-height: 12px;
                  margin-bottom: 17px;
                }
              }
            }
          }
        }

        .content-settings-student {
          .content-settings-title {
            span {
              &:first-child {
                width: 80%;
              }
              &:nth-child(n+2) {
                width: 20%;
              }
            }
          }
          .ul {
            .li {
              padding: 0 20px;
              .checked-settings {
                width: 80%;
              }
              .input-Score {
                width: 20%;
              }
            }
          }
        }
      }
    }
  }

  .popup-delete {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner{
      width: 420px;
      height: 200px;
      // .popup-head {
        // border-bottom: 0 none;
      // }
      .popup-content{
        font-size: 16px;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -5px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          font-size: 16px;
          text-align: center;
          padding: 20px 0;
          margin-top: 25px;
        }
      }
    }

    .popupbutton {
      width: 100%;
      height: 70px;
      background-color: #fff;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 99;
      button {
        color: #FFF;
        height: 40px;
        background-color: #4C88FF;
        border: 1px solid #4C88FF;
        border-radius: 3px;
        padding: 12px 20px;
        cursor: pointer;
        &:first-child {
          margin-right: 20px;
        }
      }
    }
  }
  .popup-delete-2 {
    .popup-del-cnt {
      margin-top: 10px;
      .head {
        text-align: center;
       }
    }
  }

  /deep/.popup-inner .popup-buttons .el-button.cancel {
    display: none;
  }
}
</style>
